import {Modal, Button} from '@goproblems/ui';
import {useTranslation} from 'react-i18next';
import {useFetchProblemChangesQuery} from '@api';
import {hideModal, MODAL_CHANGE_HISTORY, useSelector} from '@utils';
import {ChangeHistoryTable} from '@components';

export const ChangeHistoryModal = ({
    problemId,
    name = MODAL_CHANGE_HISTORY,
}: {
    problemId: number;
    name?: string;
}) => {
    const {t} = useTranslation();

    const {data: changes} = useFetchProblemChangesQuery(problemId);
    const show = useSelector(s => s.modalChangeHistory);

    const handleClose = () => {
        hideModal(name);
    };

    return (
        <Modal size="xl" show={show} onHide={handleClose} scrollable>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t('problem_draft.change_history_for_problem')} #{problemId}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="overflow-x-scroll">
                <ChangeHistoryTable changes={changes || []} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('problem_draft.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
